<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!-- <bita-ibox :is-loading="isLoading"> -->
        <!-- <div slot="header">
            <div class="ibox-title">
              <h4>اطلاعات یک هفته اخیر</h4>
            </div>
          </div> -->
        <!-- <div slot="body"> -->
        <div class="k-rtl">
          <div class="row">
            <!-- <div class="col-lg-3">
              <div
                class="widget style1 red-bg"
                @click="
                  goto({ query: { is_new: 1 }, path: 'management/users' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-user-plus fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>کاربران جدید</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.new_users_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-lg-3">
              <div
                class="widget style1 navy-bg"
                @click="goto({ query: { is_new: 1 }, path: '/shop/products' })"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-cart-plus fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>محصول جدید</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.products_count_new }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-lg-3">
              <div
                class="widget style1 lazur-bg"
                @click="
                  goto({ query: { status_order: 1 }, path: '/shop/orders' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-shopping-basket fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>تعداد سفارش </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 yellow-bg"
                @click="goto('/management/comments')"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-comments fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span> نظر ثبت شده </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.comments_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div> -->
            <div class="col-lg-3">
              <div
                class="widget style1 orange-bg"
                @click="goto('/management/users')"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-users fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span> کاربران عضو </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.users_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 purple-bg"
                @click="
                  goto({ query: { newsletter: 1 }, path: 'management/users' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="far fa-newspaper fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>تعداد خبرنامه </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.news_letter_users_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 cyan-bg"
                @click="goto('/shop/products')"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-boxes fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>تعداد محصولات </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.products_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="widget style1 red-bg" @click="goto('/shop/orders')">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-shopping-cart fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>کل سفارشات </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 navy-bg"
                @click="
                  goto({ query: { status_order: 3 }, path: 'shop/orders' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-truck fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>سفارشات ارسال شده</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count_sent }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 lazur-bg"
                @click="
                  goto({ query: { status_order: 1 }, path: 'shop/orders' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-cash-register fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>سفارشات بررسی نشده</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count_cargochecking }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 navy-bg"
                @click="
                  goto({ query: { status_order: 2 }, path: 'shop/orders' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-truck fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span> آماده ارسال</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count_cargochecking }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 orange-bg"
                @click="goto('/payment/transactions')"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-calculator fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>مجموع پرداختی ها</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ $thousandSeprator(total.sum_payable) }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 purple-bg"
                @click="
                  goto({ query: { status: 0 }, path: 'management/comments' })
                "
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-comment-slash fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>کامنت های تایید نشده</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.comments_not_confirmed_count }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div
                class="widget style1 red-bg"
                @click="goto('management/users')"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-wallet fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>موجودی کیف پول کاربران</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ $thousandSeprator(total.sum_credit) }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-3">
              <div class="widget style1 navy-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-cart-plus fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>موجودی پیامک</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.products_count }}
                    </h2>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- </bita-ibox> -->
      <!-- </div> -->
    </div>
    <div class="row mt-2 mb-5">
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <div slot="body">
            <div class="k-rtl">
              <bar-chart :data="charts.orders" title="تعداد سفارش" />
            </div>
          </div>
        </bita-ibox>
      </div>
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <div slot="body">
            <div class="k-rtl">
              <bar-chart :data="charts.users" title="تعداد کاربران" />
            </div>
          </div>
        </bita-ibox>
      </div>
    </div>

    <div class="row mt-2 mb-5">
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <!-- <div slot="header">
            <div class="ibox-title">
              <h4>آمار درامد روزانه هفته اخیر</h4>
            </div>
          </div> -->
          <div slot="body">
            <div class="k-rtl">
              <h4>آمار درامد روزانه هفته اخیر</h4>
              <table class="table table-hover margin bottom">
                <thead>
                  <tr>
                    <th style="width: 1%" class="text-center">ردیف</th>
                    <th class="text-center">روز</th>
                    <th class="text-center">تعداد سفارش</th>
                    <th class="text-center">{{ $currencyLabel("درامد") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) of total.week_income" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{ $getJalaliDate(item.day) }}</td>
                    <td class="text-center">{{ item.count }}</td>
                    <td class="text-center">
                      <span
                        :class="{
                          label: true,
                          'label-primary':
                            Number(item.total_income) >
                            Number(total.avg_income),
                          'label-warning':
                            Number(item.total_income) <=
                            Number(total.avg_income),
                        }"
                        >{{
                          $thousandSeprator($round(item.total_income))
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </bita-ibox>
      </div>
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <!-- <div slot="header">
            <div class="ibox-title">
              <h4>سفارش های جدید</h4>
            </div>
          </div> -->
          <div slot="body">
            <div class="k-rtl">
              <router-link
                :to="{
                  path: '/shop/orders',
                  query: { payment_status: 1, status_order: 1 },
                }"
              >
                <h4>سفارش های بررسی نشده</h4>
              </router-link>
              <table
                v-if="total && total.orders && total.orders.length > 0"
                class="table table-hover margin bottom"
              >
                <thead>
                  <tr>
                    <th style="width: 1%" class="text-center">ردیف</th>
                    <th>نام</th>
                    <th class="text-center">زمان ثبت سفارش</th>
                    <th class="text-center">{{ $currencyLabel("مبلغ") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) of total.orders"
                    :key="index"
                    @click="() => openModal(item)"
                  >
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ item.full_name }}</td>
                    <td class="text-center small">
                      {{ $getJalaliDateTime(item.created_at) }}
                    </td>
                    <td class="text-center">
                      <span class="label label-primary">{{
                        $thousandSeprator(item.payable)
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center" v-else>سفارش جدیدی ثبت نشده است</div>
            </div>
          </div>
        </bita-ibox>
      </div>
    </div>

    <div class="row" v-if="$showDashboardWarnings">
      <div class="col-lg-6">
        <div>
          <table class="table">
            <tbody>
              <tr>
                <td>
                  <button type="button" class="btn btn-danger m-r-sm">
                    <div v-if="isLoading">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                    {{ total.jobs_count }}
                  </button>
                  فعالیت های در صف
                </td>
                <td>
                  <button type="button" class="btn btn-danger m-r-sm">
                    <div v-if="isLoading">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                    {{ total.orders_count_new }}
                  </button>
                  بررسی نشده
                </td>
              </tr>
              <tr>
                <td>
                  <button type="button" class="btn btn-warning m-r-sm">
                    <div v-if="isLoading">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                    {{ total.failed_jobs_count }}
                  </button>
                  فعالیت های ناموفق
                </td>
                <td>
                  <button type="button" class="btn btn-warning m-r-sm">
                    <div v-if="isLoading">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                    {{ total.orders_count_cargochecking }}
                  </button>
                  بررسی انبار
                </td>
              </tr>
              <tr>
                <td>
                  <button type="button" class="btn btn-info m-r-sm">
                    <div v-if="isLoading">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                    {{ sysStatus.sms_credit ? sysStatus.sms_credit.value : "" }}
                  </button>
                  موجودی پیامک
                </td>
                <td>
                  <button type="button" class="btn btn-success m-r-sm">
                    <div v-if="isLoading">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                    {{ total.orders_count_sent }}
                  </button>
                  ارسال شده
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="col-2"
        v-if="
          sysStatus.last_job_runtime && sysStatus.last_job_runtime.alarm_status
        "
      >
        <div class="widget yellow-bg p-lg text-center">
          <div class="m-b-md">
            <i class="fas fa-exclamation-triangle fa-4x"></i>
            <h1 class="m-xs">هشدار</h1>
            <h3 class="font-bold no-margins">ایجاد</h3>
            <small>اشکال در سیستم وظایف</small>
          </div>
        </div>
      </div>
      <div
        class="col-2"
        v-if="
          sysStatus.last_sms_delivery_check &&
            sysStatus.last_sms_delivery_check.alarm_status
        "
      >
        <div class="widget yellow-bg p-lg text-center">
          <div class="m-b-md">
            <i class="fas fa-exclamation-triangle fa-4x"></i>
            <h1 class="m-xs">هشدار</h1>
            <h3 class="font-bold no-margins">ایجاد</h3>
            <small>اشکال در سیستم چک دلیوری</small>
          </div>
        </div>
      </div>
      <div
        class="col-2"
        v-if="sysStatus.sms_credit && sysStatus.sms_credit.alarm_status"
      >
        <div class="widget yellow-bg p-lg text-center">
          <div class="m-b-md">
            <i class="fas fa-exclamation-triangle fa-4x"></i>
            <h1 class="m-xs">هشدار</h1>
            <h3 class="font-bold no-margins">کمبود</h3>
            <small>شارژ حساب پیامک ({{ sysStatus.sms_credit.value }}) </small>
          </div>
        </div>
      </div>
    </div>
    <order-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      modal-id="edit-modal"
      :settings="settings"
      title="ویرایش درخواست"
      @on-submit="handleEdit"
      @on-update="handleUpdatePaymentStatus"
    />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import { dashboardApi, orderApi } from "@/api/apiManagement.js";
import BarChart from "../../components/template/BarChart.vue";
import OrderModal from "./components/OrderForm";

export default {
  name: "Home",
  components: { BarChart, OrderModal },
  data() {
    return {
      dashboard: {},
      total: {},
      sysStatus: {},
      charts: {},
      isLoading: false,
      isLoadingModal: false,
      settings: {},
    };
  },
  mounted() {
    this.getDashboardData();
    if (this.$store.state.layout != "app-layout") this.$setLayout("app-layout");
  },
  methods: {
    goto(input) {
      return this.$router.push(input);
    },
    getDashboardData() {
      this.isLoading = true;
      dashboardApi.getInfo().then(({ data }) => {
        this.dashboard = data;
        this.total = data.total;
        this.charts = data.charts;
        this.sysStatus = data.system_statuses;
        this.isLoading = false;
        this.settings = data.settings;
        console.log("__", this.charts.orders);
      });
    },
    handleEdit(_data) {
      this.$alert("question", `از انجام عملیات بروزرسانی مطمعن هستید؟`, "", {
        confirmButtonText: "تایید",
      }).then((result) => {
        if (result.value) {
          this.updateOrder(_data);
        }
      });
    },
    updateOrder(data) {
      this.isLoadingModal = true;

      orderApi
        .updateOrder(data.id, data.form_data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق");

          this.updateForm = {
            name: "",
            parent_id: "",
          };

          this.$refs.editModal.reset();

          let index = this.total.orders.findIndex(
            (v) => v.id == data.id && data.status != 1
          );

          if (index > -1) this.total.orders.splice(index, 1);
          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleUpdatePaymentStatus(e) {
      this.isLoadingModal = true;

      this.$alert(
        "question",
        `از تغییر وضعیت این سفارش به پرداخت موفق مطمئن هستید ؟`,
        "",
        {
          confirmButtonText: "تایید",
        }
      ).then((result) => {
        if (result.value) {
          orderApi
            .updateOrderPaymentStatus(e.id, e)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق");
              this.loadData();
              this.statusChangeModalEdit();
            })
            .finally(() => {
              this.isLoadingModal = false;
            });
        }
      });
    },
    openModal(request) {
      this.$refs.editModal.setInitialData(request);
      this.statusChangeModalEdit();
    },
    statusChangeModalEdit() {
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
  },
};
</script>
